import { API_config } from '../../config/apiConfig';

const apiUrl = API_config.apiUrl;
const username = API_config.username;
const password = API_config.password;
const authHeader = API_config.authHeader;

// Function to fetch device positions and details
/*
export async function fetchDevicePositions() {
  try {
    const [positionsResponse, devicesResponse] = await Promise.all([
      fetch(`${apiUrl}/positions`, {
        headers: {
          'Authorization': authHeader,
        },
      }),
      fetch(`${apiUrl}/devices`, {
        headers: {
          'Authorization': authHeader,
        },
      }),
    ]);

    if (!positionsResponse.ok || !devicesResponse.ok) {
      throw new Error('Failed to fetch device data.');
    }

    const positionsData = await positionsResponse.json();
    const devicesData = await devicesResponse.json();

    // Combine positions and devices based on device ID, including the model from device data
    const combinedData = positionsData.map(position => {
      const device = devicesData.find(device => device.id === position.deviceId);
      return {
        ...position,
        deviceName: device ? device.name : '',
        model: device ? device.model : '', // Include model from device
      };
    });

    return combinedData;
  } catch (error) {
    console.error(error);
    return null;
  }
}
*/


// Function to fetch speed data for the last 5 minutes for a specific device
export async function fetchSpeedData(deviceId) {
    // Credentials used from top-level scope (imported from config)

    const now = new Date();
    const from = new Date(now.getTime() - 5 * 60 * 1000).toISOString(); // 5 minutes ago
    const to = now.toISOString(); // Current time

    try {
        const response = await fetch(`${apiUrl}/positions?deviceId=${deviceId}&from=${from}&to=${to}`, {
            headers: { 'Authorization': authHeader },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch speed data.');
        }

        const data = await response.json(); // Ensure this is declared properly
        return data; // Return the data

    } catch (error) {
        console.error(error);
        return null;
    }
}
export async function fetchLatestSpeedData(deviceId) {
    // Uses top-level credentials

    try {
        const response = await fetch(`${apiUrl}/positions?deviceId=${deviceId}&limit=1&order=desc`, {
            headers: { 'Authorization': authHeader },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch latest speed data.');
        }

        const data = await response.json();
        return data[0]; // Return only the latest data point
    } catch (error) {
        console.error(error);
        return null;
    }
}
